import { FEATURE_NAMES } from '../../loaders/features/features.mjs';

const FEATURE_NAME = FEATURE_NAMES.jserrors;

export { FEATURE_NAME };
//# sourceMappingURL=constants.mjs.map
